import { useEffect } from "react";
import { useInputProps } from "../components/EramInput.js";
export function useMenuFreeTextEntry(path, validate, onValid, onInvalid, resyncValue) {
    const { showInput, ...inputProps } = useInputProps(path, "", (v) => {
        if (validate(v)) {
            onValid(v);
        }
        else {
            onInvalid();
        }
    }, { initialShowInput: false });
    useEffect(() => {
        if (resyncValue !== undefined && !showInput) {
            inputProps.setInputValue(resyncValue);
        }
    }, [resyncValue, inputProps, inputProps.setInputValue, showInput]);
    return { showInput, inputProps };
}
//# sourceMappingURL=useMenuFreeTextEntry.js.map